<template>
  <div>
    <div class="content">
      <img
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/000044af9f9f301f8c2efbedbb7b8ef2.jpg"
      />
      <img
        class="btn"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cb4456ae1da422385a63801cbd9807aa.jpg"
        @click="bindClick"
        alt=""
      />
    </div>
    <van-overlay :show="showOverlay" z-index="3">
      <div class="wrapper" @click.stop>
        <QuestinInfo @cancel="bindCancel" @submit="bindSubmit" />
      </div>
    </van-overlay>
  </div>
</template>
<script>
;(function (r, d, s) {
  r._tt_config = true
  var _baq = (r._baq = r._baq || [])
  _baq.methods = ['track', 'off', 'on']
  _baq.factory = function (method) {
    return function () {
      var args = Array.prototype.slice.call(arguments)
      args.unshift(method)
      _baq.push(args)
      return _baq
    }
  }
  for (var i = 0; i < _baq.methods.length; i++) {
    var key = _baq.methods[i]
    _baq[key] = _baq.factory(key)
  }
  _baq.load = function () {
    var js,
      fjs = d.getElementsByTagName(s)[0]
    js = d.createElement(s)
    js.src = 'https://analytics.oceanengine.com/api/v2/js/sdk'
    fjs.parentNode.insertBefore(js, fjs)
  }
  _baq.load()
  if (_baq.invoked) {
    return
  }
  _baq.invoked = true
  _baq.track('pageview')
})(window, document, 'script')
import QuestinInfo from './components/question-info.vue'
export default {
  components: {
    QuestinInfo
  },
  data() {
    return {
      showOverlay: false,
      isClickedBtn: false, //按钮是否被点击过
      submiting: false,
      assetsData: {
        0: '1802271935825947'
      }
    }
  },
  mounted() {
    setTimeout(() => {
      if (!this.isClickedBtn) {
        this.showOverlay = true
      }
    }, 5000)
  },
  methods: {
    bindClick() {
      this.isClickedBtn = true
      this.showOverlay = true
    },
    bindCancel() {
      this.showOverlay = false
    },
    bindSubmit(questionData) {
      if (this.submiting) {
        return
      }
      this.submiting = true
      let params = Object.assign(
        {
          version: 2
        },
        questionData
      )
      this.$http
        .postApp('api/v1/HugeEngine/add', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('提交成功')
            _baq.track('form', {
              assets_id: this.assetsData[+this.$route.query.from || 0]
            })
            this.bindCancel()
            setTimeout(() => {
              this.$router.push('/nutritionist-training-program/add-customer')
            }, 300)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
        .finally(() => {
          this.submiting = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  padding-bottom: 58px;
  img {
    width: 100%;
    height: auto;
  }

  .btn {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 2;
  }
}
.wrapper {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
